import React, { useState, useEffect } from "react";
import {
  Button, Row, Col, Offcanvas, OffcanvasHeader, OffcanvasBody,
} from "reactstrap";
import { withTranslation } from "react-i18next";
import { AvForm, AvField } from "availity-reactstrap-validation";
import FromToDate from "../../components/Common/Filters/FromToDate";
import { getEventFilterOptions } from "../../apis/events";

const initValues = {
  isLead: "",
  eventKey: "",
  customerEmail: "",
  country: "",
  filterDate: {
    fromDate: "",
    toDate: "",
  },
};

function EventsFilter(props) {
  const [openCanvas, setOpenCanvas] = useState(false);
  const { filteredValues = initValues } = props;
  const [values, setValues] = useState(filteredValues);
  const [filtered, setFilter] = useState(false);
  const [options, setOptions] = useState({
    events: [],
    countries: [] 
  });

  useEffect(() => {
    setFilter(JSON.stringify(initValues) !== JSON.stringify(values));
  }, [values]);

  useEffect(() => {
    getEventFilterOptions()
      .then((data) => setOptions({
        events: data?.events || [],
        countries: data?.countries || [],
      }))
      .catch(() => setOptions({
        events: [],
        countries: [] 
      }));
  }, []);

  const toggleCanvas = () => setOpenCanvas(!openCanvas);

  const resetFilter = () => {
    setValues(initValues);
    props.filterChangeHandler(initValues);
  };

  const dateChangeHandler = (filterDate) => setValues({
    ...values,
    filterDate,
  });

  return (
    <React.Fragment>
      <Button color="primary" className="ms-2" onClick={toggleCanvas}>
        <i className="bx bx-filter me-1" />
        {filtered ? props.t("Update Filter") : props.t("Filter")}
      </Button>
      <Offcanvas isOpen={openCanvas} direction="end" scrollable toggle={toggleCanvas}>
        <OffcanvasHeader toggle={toggleCanvas} tag="h4">
          {props.t("Filter Events")}
        </OffcanvasHeader>
        <OffcanvasBody>
          <AvForm
            className="p-4"
            onValidSubmit={() => {
              props.filterChangeHandler(values);
              setOpenCanvas(false);
            }}
          >
            <Row>
              <Col md="12">
                <div className="mb-3">
                  <AvField
                    type="select"
                    name="eventKey"
                    label={props.t("Event")}
                    value={values.eventKey}
                    onChange={(e) => setValues({
                      ...values,
                      eventKey: e.target.value,
                    })}
                  >
                    <option value="">{props.t("All Events")}</option>
                    {options.events.map((event) => (
                      <option key={event.eventKey} value={event.eventKey}>
                        {event.eventName}
                      </option>
                    ))}
                  </AvField>
                </div>
              </Col>
            </Row>
            <Row>
              <Col md="12">
                <div className="mb-3">
                  <AvField
                    name="customerEmail"
                    label={props.t("Customer Email")}
                    placeholder={props.t("Enter customer email")}
                    value={values.customerEmail}
                    onChange={(e) => setValues({
                      ...values,
                      customerEmail: e.target.value,
                    })}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <div className="mb-3">
                  <AvField
                    type="select"
                    name="isLead"
                    label={props.t("Type")}
                    value={values.isLead}
                    onChange={(e) => setValues({
                      ...values,
                      isLead: e.target.value,
                    })}
                  >
                    <option value="">{props.t("All")}</option>
                    <option value="true">{props.t("Lead")}</option>
                    <option value="false">{props.t("Client")}</option>
                  </AvField>
                </div>
              </Col>
              <Col md="6">
                <div className="mb-3">
                  <AvField
                    type="select"
                    name="country"
                    label={props.t("Country")}
                    value={values.country}
                    onChange={(e) => setValues({
                      ...values,
                      country: e.target.value,
                    })}
                  >
                    <option value="">{props.t("All Countries")}</option>
                    {options.countries.map((country) => (
                      <option key={country} value={country}>
                        {country}
                      </option>
                    ))}
                  </AvField>
                </div>
              </Col>
            </Row>
            <div className="mb-3">
              <FromToDate
                utcDate
                filterDate={values.filterDate}
                dateChangeHandler={dateChangeHandler}
              />
            </div>
            <div className="row">
              <div className="col-sm-12 text-center">
                <Button type="submit" color="primary" className="btn btn-primary btn-md center-block">
                  {props.t("Filter")}
                </Button>
                {" "}
                <Button disabled={!filtered} onClick={resetFilter} color="danger" type="reset" className="btn btn-danger btn-md center-block">
                  {props.t("Reset")}
                </Button>
              </div>
            </div>
          </AvForm>
        </OffcanvasBody>
      </Offcanvas>
    </React.Fragment>
  );
}

export default withTranslation()(EventsFilter);
